<template>
    <div>
        <!--div class="title">Thông tin học viên</div>
        <div>
            <v-text-field label="Họ và tên" disabled v-model="editingMember.fullName"/>
            <v-text-field label="Email" disabled v-model="editingMember.email"/>
            <v-text-field label="Số điện thoại" disabled v-model="editingMember.phone"/>
            <i-datepicker label="Ngày sinh" disabled v-model="user.birthday"/>
            <v-text-field label="Giới tính" disabled v-model="user.gender"/>
            <v-text-field label="Mục tiêu học tập" disabled v-model="editingMember.target"/>
            <v-text-field label="Họ tên phụ huynh" v-model="editingMember.parentName"/>
            <v-text-field label="Email phụ huynh" v-model="editingMember.parentEmail"
                          v-validate="'email'"
                          key="parentEmail"
                          name="parentEmail"
                          data-vv-as="Email phụ huynh"
                          :error-messages="errors.first('parentEmail')"
            />
            <v-text-field label="Số điện thoại phụ huynh" v-model="editingMember.parentPhone"
                          v-validate="{regex: /^[0-9()-]*$/im }"
                          key="parentPhone"
                          name="parentPhone"
                          data-vv-as="Số điện thoại phụ huynh"
                          :error-messages="errors.first('parentPhone')"
            />
        </div-->
        <fieldset style="padding: 20px;border:1px solid #daf2e6">
            <legend class="primaryColor" v-if="viewType=='student'">Học Sinh:</legend>
            <legend class="primaryColor" v-else>Giáo viên:</legend>
            <v-layout>
                <v-flex xs2 sm2 md2 lg2 xl2>
                </v-flex>
                <v-flex xs7 sm7 md7 lg7 xl7>
                    <v-text-field label="Họ và tên" disabled v-model="editingMember.fullName"/>
                    <i-datepicker label="Ngày sinh" disabled v-model="user.birthday"/>
                    <v-radio-group v-model="user.gender"
                                   name="gender"
                                   key="gender"
                                   disabled
                                   :error-messages="errors.first('gender')"
                                   data-vv-as="Giới tính"
                                   label="Giới tính">
                        <v-radio
                                key="maleGender"
                                label="Nam"
                                :value="true"
                        ></v-radio>
                        <v-radio
                                key="femaleGender"
                                label="Nữ"
                                :value="false"
                        ></v-radio>
                    </v-radio-group>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs2 sm2 md2 lg2 xl2>
                </v-flex>
                <v-flex xs7 sm7 md7 lg7 xl7>
                    <v-text-field type="text" :label="$t('lang.user.email') " v-model.trim="editingMember.email"
                                  name="email"
                                  maxLength="50"
                                  v-validate="'email'"
                                  :data-vv-as="$t('lang.user.email')"
                                  :error-messages="errors.first('email')"/>
                    <v-text-field type="text" :label="$t('lang.user.phone')" v-model.trim="editingMember.phone"
                                  name="phone"
                                  maxLength="50"
                                  v-validate="{ regex: /^[0-9()-]*$/im }"
                                  :data-vv-as="$t('lang.user.phone')"
                                  :error-messages="errors.first('phone')"/>
                    <v-text-field type="text" :label="$t('lang.user.yolearn')"
                                  v-model.trim="editingMember.yolearn"
                                  name="yolearn"
                                  key="yolearn"
                                  maxLength="20"
                                  :data-vv-as="$t('lang.user.yolearn')"
                                  :error-messages="errors.first('yolearn')"/>
                    <v-text-field type="text" :label="$t('lang.user.zalo')" v-model.trim="editingMember.zalo"
                                  name="zalo"
                                  key="zalo"
                                  maxLength="50"
                                  :data-vv-as="$t('lang.user.zalo')"
                                  :error-messages="errors.first('zalo')"/>
                </v-flex>
                <v-flex xs3 sm3 md3 lg3 xl3 style="text-align: right">
                    <v-checkbox name="notifyEmail" key="notifyEmail" v-model="editingMember.notifyEmail"/>
                    <v-checkbox name="notifySMS" key="notifySMS" v-model="editingMember.notifySms"/>
                    <v-checkbox name="notifyYolearn" key="notifyYolearn" v-model="editingMember.notifyYolearn"/>
                    <v-checkbox name="notifyZalo" key="notifyZalo" v-model="editingMember.notifyZalo"/>
                </v-flex>
            </v-layout>
        </fieldset>
        <fieldset style="padding: 20px;border:1px solid #daf2e6" v-if="viewType=='student'">
            <legend class="primaryColor">Phụ huynh:</legend>
            <v-layout>
                <v-flex xs2 sm2 md2 lg2 xl2>
                </v-flex>
                <v-flex xs7 sm7 md7 lg7 xl7>
                    <v-text-field type="text" :label="$t('lang.user.email') "
                                  v-model.trim="editingMember.parentEmail"
                                  name="parentEmail"
                                  key="parentEmail"
                                  maxLength="50"
                                  v-validate="'email'"
                                  :data-vv-as="$t('lang.user.email')"
                                  :error-messages="errors.first('parentEmail')"/>
                    <v-text-field type="text" :label="$t('lang.user.phone')"
                                  v-model.trim="editingMember.parentPhone"
                                  v-validate="{ regex: /^[0-9()-]*$/im }"
                                  name="parentPhone"
                                  key="parentPhone"
                                  maxLength="50"
                                  :data-vv-as="$t('lang.user.phone')"
                                  :error-messages="errors.first('parentPhone')"/>
                    <v-text-field type="text" :label="$t('lang.user.yolearn')"
                                  v-model.trim="editingMember.parentYolearn"
                                  name="parentYolearn"
                                  key="parentYolearn"
                                  maxLength="50"
                                  :data-vv-as="$t('lang.user.yolearn')"
                                  :error-messages="errors.first('parentYolearn')"/>
                    <v-text-field type="text" :label="$t('lang.user.zalo')"
                                  v-model.trim="editingMember.parentZalo"
                                  name="parentZalo"
                                  key="parentZalo"
                                  maxLength="50"
                                  :data-vv-as="$t('lang.user.zalo')"
                                  :error-messages="errors.first('parentZalo')"/>
                </v-flex>
                <v-flex xs3 sm3 md3 lg3 xl3 style="text-align: right">
                    <v-checkbox name="notifyParentEmail" key="notifyParentEmail"
                                v-model="editingMember.notifyParentEmail"/>
                    <v-checkbox name="notifyParentSMS" key="notifyParentSMS"
                                v-model="editingMember.notifyParentSMS"/>
                    <v-checkbox name="notifyParentYoteacher" key="notifyParentYoteacher"
                                v-model="editingMember.notifyParentYolearn"/>
                    <v-checkbox name="notifyParentZalo" key="notifyParentZalo"
                                v-model="editingMember.notifyParentZalo"/>
                </v-flex>
            </v-layout>
        </fieldset>
        <fieldset style="padding: 20px;border:1px solid #daf2e6" v-if="viewType=='student'">
            <legend class="primaryColor">THÔNG TIN HỌC TẬP:</legend>
            <v-layout>
                <v-flex xs2 sm2 md2 lg2 xl2>
                </v-flex>
                <v-flex xs7 sm7 md7 lg7 xl7>
                    <v-text-field label="Mục tiêu điểm số" v-model.trim="editingMember.markTarget"
                                  name="markTarget"
                                  key="markTarget"
                                  v-validate="'decimal:2'"
                                  maxLength="10"
                                  data-vv-as="Mục tiêu điểm số"
                                  :error-messages="errors.first('markTarget')"/>
                    <v-text-field label="Điểm trung bình đạt được" v-model.trim="editingMember.markAverageTarget"
                                  name="markAverageTarget"
                                  key="markAverageTarget"
                                  v-validate="'decimal:2'"
                                  maxLength="10"
                                  data-vv-as="Điểm trung bình đạt được"
                                  :error-messages="errors.first('markAverageTarget')"/>
                    <v-text-field label="Mục tiêu thi cử" v-model.trim="editingMember.examTarget"
                                  name="examTarget"
                                  key="examTarget"
                                  maxLength="250"
                                  data-vv-as="Mục tiêu thi cử"
                                  :error-messages="errors.first('examTarget')"/>
                    <v-text-field label="Tên trường muốn thi đỗ"
                                  v-model.trim="editingMember.university"
                                  name="university"
                                  key="university"
                                  maxLength="250"
                                  data-vv-as="Tên trường muốn thi đỗ"
                                  :error-messages="errors.first('university')"/>
                    <v-text-field label="Mục tiêu khác" v-model.trim="editingMember.otherTarget"
                                  name="otherTarget"
                                  key="otherTarget"
                                  maxLength="250"
                                  data-vv-as="Mục tiêu khác"
                                  :error-messages="errors.first('otherTarget')"/>
                </v-flex>
            </v-layout>
        </fieldset>

        <div class="buttonBar">
            <v-btn color="cancel" @click="cancel">
                {{$t('lang.common.cancel')}}
            </v-btn>
            <v-btn class="yoprimary" dark @click="saveMemberProfile" v-if="$store.state.auth.user.role==4 || $store.state.auth.user.role==2">
                {{$t('lang.common.save')}}
            </v-btn>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import {Validator, ValidationObserver} from "vee-validate";
    import IDatepicker from "../../components/form/DatePicker";

    export default {
        name: "member-detail",

        components: {
            IDatepicker,
            ValidationObserver
        },
        props: {
            classId: {
                type: String | Number,
                default: null
            },

            viewType:{
                type: String,
                default:()=> {
                    return "student";
                }
            },

            editingMember: {
                type: Object,
                default: null
            },

            user: {
                type: Object,
                default: null
            },
        },

        data: () => ({
            student:{},
        }),

        computed: {},

        watch: {
        },

        mounted() {
        },

        created() {
        },

        methods: {
            saveMemberProfile: function () {
                this.$validator.validate().then(valid => {
                    if(!valid){
                        return;
                    }
                    axios.post(process.env.VUE_APP_API_URL + "/classmember/updateNotify", this.editingMember).then(
                        data => {
                            if (data.success) {
                                message.success(this.$t('lang.common.save_success'));
                                this.cancel();
                            } else {
                                message.error(data.description);
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    )
                }
                );
            },

            cancel: function(){
                this.$emit("cancel");
            }
        }
    };
</script>